// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__fIHO2","logo":"Footer_logo__2_DXK"};